import React from 'react';

/**
 * Plain text cell — rendered when the grid (or the row) is in read-only mode,
 * or when a column declares cellType: 'readonlyText'.
 *
 * cellRendererParams (merged with column.cellProps):
 *   accessor(row) => string   optional value selector (falls back to params.value)
 *   fallback     string       default '--'
 */
function ReadonlyTextCell(params) {
  const { value, data, accessor, fallback = '--' } = params;
  const text = typeof accessor === 'function' ? accessor(data) : value;
  const display = text === undefined || text === null || text === '' ? fallback : String(text);
  return (
    <div className="cag-cell cag-cell-readonly">
      <span title={display}>{display}</span>
    </div>
  );
}

export default ReadonlyTextCell;
